'use strict';

angular.module('app.advertiserProjectList', [])

.controller('advertiserProjectListCtrl', ['$scope', '$rootScope', '$http', '$state', '$modal', 'localStorageService', 'commonPagesService', 'TRACK_EVENTS', function ($scope, $rootScope, $http, $state, $modal, localStorageService, commonPagesService, TRACK_EVENTS) {
        
        $scope.currentUser = $rootScope.currentUser;
        $scope.enableNewProject = false;
        $scope.isFetching = false;

        $scope.firstLoad = function () {
            if($scope.currentUser.accessibility.leftMenu.showCurrentlyManaging == false && $scope.currentUser.accessibility.leftMenu.showProjects == true) {
                $scope.allProjectsData = $scope.currentUser.company.projects;
                $scope.enableNewProject = true;
                if($rootScope.autoSelectProject == true) {
                    $scope.selectFirstProject();    
                    $rootScope.autoSelectProject = false;
                }
            }

            $rootScope.projectsForSelectedAdvertiser = $scope.allProjectsData;
        }
        
        $scope.$on('reload_advertiserProjectList', function (event, args) {
            if(args.advertiserId) {
                $scope.isFetching = true;
                commonPagesService.getAllProjectByAdvertiserID(args.advertiserId, false)
                    .then(function (response) {
                        $scope.allProjectsData = response.data; 
                        $scope.enableNewProject = true;  
                        if($rootScope.autoSelectProject == true) {
                            $scope.selectFirstProject();    
                            $rootScope.autoSelectProject = false;
                        }

                        $rootScope.projectsForSelectedAdvertiser = $scope.allProjectsData;
                        $scope.isFetching = false;
                    }, function () {
                        $scope.isFetching = true;
                        return false;
                    })
                    .finally(function () {
                    });
            }            
        })

        $scope.$on('add_advertiserProjectList', function (event, args) {
            if(args.projectData != null) {
                $scope.allProjectsData.push(args.projectData);

                if($scope.currentUser.accessibility.leftMenu.showCurrentlyManaging == false && $scope.currentUser.accessibility.leftMenu.showProjects == true) {
                    $scope.currentUser.company.projects = $scope.allProjectsData;
                    $rootScope.currentUser.company.projects = $scope.allProjectsData;
                    localStorageService.set('currentUser', $scope.currentUser);
                }

                $rootScope.projectsForSelectedAdvertiser = $scope.allProjectsData;
            }            
        })

        $scope.$on('delete_advertiserProjectList', function (event, args) {
            if(args.projectData != null) {
                var projects = [];
                $scope.allProjectsData.forEach(function (project, index) {
                    if (project.id != args.projectData.id) {
                        projects.push(project);
                    }
                })

                $scope.allProjectsData = projects;

                if($scope.currentUser.accessibility.leftMenu.showCurrentlyManaging == false && $scope.currentUser.accessibility.leftMenu.showProjects == true) {
                    $scope.currentUser.company.projects = $scope.allProjectsData;
                    $rootScope.currentUser.company.projects = $scope.allProjectsData;
                    localStorageService.set('currentUser', $scope.currentUser);
                }
                
                $rootScope.projectsForSelectedAdvertiser = $scope.allProjectsData;

                $(".project_").remove();
                $location.path('/dashboard');
            }            
        })

        $scope.$on('update_advertiserProjectList', function (event, args) {
            if(args.projectData != null) {
                $scope.allProjectsData.forEach(function (project, index) {
                    if (project.id == args.projectData.id) {
                        project.name = args.projectData.name;
                        project.projectKeywords = args.projectData.projectKeywords;
                    }
                })

                if($scope.currentUser.accessibility.leftMenu.showCurrentlyManaging == false && $scope.currentUser.accessibility.leftMenu.showProjects == true) {
                    $scope.currentUser.company.projects = $scope.allProjectsData;
                    $rootScope.currentUser.company.projects = $scope.allProjectsData;
                    localStorageService.set('currentUser', $scope.currentUser);
                }

                $rootScope.projectsForSelectedAdvertiser = $scope.allProjectsData;
            }            
        })

        $scope.markKeyword = function (id) {
            $(".kws ul li a").removeClass("active");
            $(".influencers ul li a").removeClass("active");
            $(".preferred ul li").removeClass('activePreferred');

            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers li a').removeClass('active');
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('active');
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('not-selected');
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers').hide();

            $('.main-sidebar .campaigns .nav-sidebar .campaign').removeClass('active');

            $('.main-sidebar .projects .nav-sidebar .project.active').addClass('not-selected');
            $('.main-sidebar .projects .nav-sidebar .project .kws li a').removeClass('active');
            $("#kw_" + id).addClass('active');
        }

        $scope.markProject = function (id) {
            $(".kws ul li a").removeClass("active");
            $(".influencers ul li a").removeClass("active");
            $(".preferred ul li").removeClass('activePreferred');

            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers li a').removeClass('active');
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('active');
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup').removeClass('not-selected');
            $('.main-sidebar .influencerGroups .nav-sidebar .influencerGroup .influencers').hide();

            $('.main-sidebar .campaigns .nav-sidebar .campaign').removeClass('active');

            if ($(".projects .project_" + id).hasClass('active')) {
                $('.main-sidebar .projects .nav-sidebar .project').removeClass('not-selected');
            } else {
                $('.main-sidebar .projects .nav-sidebar .project .kws li a').removeClass('active');
                $('.main-sidebar .projects .nav-sidebar .project').removeClass('active');
                $('.main-sidebar .projects .nav-sidebar .project').removeClass('not-selected');
                $('.main-sidebar .projects .nav-sidebar .project .kws').hide();
                $(".projects .project_" + id).addClass('active').find("div.kws").show();
            }
        }

        $scope.selectProject = function (id, name) {
            // Mixpanel tracking project item click
            if (name) {
                var evtItem = TRACK_EVENTS.PAGE_STATE_MAPPING[$state.current.name];
                if (evtItem) {
                    analytics.track(
                        TRACK_EVENTS.CLICK_ON_PROJECT.EVT_NAME,
                        {
                            "item": evtItem,
                            "target_type": "Project",
                            "target_name": name,
                            "target_id": id
                        }
                    );
                }
            }

            $scope.markProject(id);

            $rootScope.sideMenuSelections.project = id;
            $rootScope.sideMenuSelections.keyword = null;
            $rootScope.sideMenuSelections.blog = null;
            $rootScope.sideMenuSelections.channel = null;           
            $rootScope.sideMenuSelections.influencerGroup = null;
            $rootScope.sideMenuSelectedName = {type: "Project", id: id, name: name};
            $rootScope.sideMenuSelectedProject = {id: id, name: name};

            $rootScope.saveParams = {
                project_id : id ? id : 0,
                mention : 0,
                blog_id : 0,
                channel: 0,
                influencerGroup: 0,
                _workaround_group_id: 0
            };

            $rootScope.$broadcast('updatePrintHeader', { printHeader : {
                type: "Project",
                name: $(".projects .project_" + id + " .project-name").text()
            }});

            $rootScope.$broadcast('refreshDashboard', {});

            if($state.current.name == "home.influencerOverview" || $state.current.name == "home.blogPostOverview" || $state.current.name == "home.instagramPostOverview" || $state.current.name == "home.youtubePostOverview") {
                $state.transitionTo("home.dashboard", null, {
                    reload: false,
                    inherit: false,
                    notify: true
                });
            }

            angular.element('#switch-' + id + '-line').addClass('selected');
        }

        $scope.selectKeyword = function (id, projectId, name, type) {
            // Mixpanel tracking mention item click
            if (name) {
                var evtItem = TRACK_EVENTS.PAGE_STATE_MAPPING[$state.current.name];
                if (evtItem) {
                    analytics.track(
                        TRACK_EVENTS.CLICK_ON_MENTION.EVT_NAME,
                        {
                            "item": evtItem,
                            "target_type": "Project",
                            "target_name": $rootScope.sideMenuSelectedProject.name,
                            "target_id": $rootScope.sideMenuSelectedProject.id,
                            "sub_target_type": type,
                            "sub_target_name": name,
                            "sub_target_id": id
                        }
                    );
                }
            }

            $scope.markKeyword(id); 

            $rootScope.sideMenuSelections.project = projectId;
            $rootScope.sideMenuSelections.keyword = id;
            $rootScope.sideMenuSelections.blog = null;
            $rootScope.sideMenuSelections.channel = null;           
            $rootScope.sideMenuSelections.influencerGroup = null;
            $rootScope.sideMenuSelectedName = {
                type: "Project",
                id: $rootScope.sideMenuSelectedProject.id, 
                name: $rootScope.sideMenuSelectedProject.name, 
                subType: type, 
                subName: name, 
                subId: id 
            };

            $rootScope.saveParams = {
                project_id : projectId ? projectId : 0,
                mention : id ? id : 0,
                blog_id : 0,
                channel: 0,
                influencerGroup: 0,
                _workaround_group_id: 0
            };

            $rootScope.$broadcast('updatePrintHeader', { printHeader : {
                type: "Keyword",
                name: $(".projects .project_" + projectId + " #kw_" + id).text()
            }});

            $rootScope.$broadcast('refreshDashboard', {});

            if($state.current.name == "home.influencerOverview" || $state.current.name == "home.blogPostOverview" || $state.current.name == "home.instagramPostOverview" || $state.current.name == "home.youtubePostOverview") {
                $state.transitionTo("home.dashboard", null, {
                    reload: false,
                    inherit: false,
                    notify: true
                });
            }
        }

        $scope.selectFirstProject = function () {
            // Ticket NL-3
            if($scope.allProjectsData != null && $scope.allProjectsData.length > 0) {
                setTimeout(function () {
                    $scope.selectProject($scope.allProjectsData[0].id, $scope.allProjectsData[0].name);
                    $rootScope.saveParams = {
                        mention: 0,
                        blog_id: 0,
                        project_id: $scope.allProjectsData[0].id,
                        channel: 0,
                        influencerGroup: 0,
                        _workaround_group_id: 0
                    }
                }, 5)
            } 
        }

        $scope.editProjectModalHandler = function (projectData) {
            var modalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/sideBarMenu/advertiserProjectList/advertiserProjectDetail/advertiserProjectDetail.html?app_v=deployDate',
                controller: 'advertiserProjectDetailCtrl',
                resolve: {
                    projectData: function() {
                        return projectData;
                    },
                    mentionData: function(){
                        return null;
                    }
                }
            });
            $scope.modalInstance = modalInstance;
        };

        $scope.newProjectModalHandler = function () {
            var modalInstance = $modal.open({
                scope: $scope,
                templateUrl: 'app/sideBarMenu/advertiserProjectList/advertiserProjectDetail/advertiserProjectDetail.html?app_v=deployDate',
                controller: 'advertiserProjectDetailCtrl',
                resolve: {
                    projectData: function() {
                        return null;
                    },
                    mentionData: function(){
                        return null;
                    }
                }
            });
            $scope.modalInstance = modalInstance;
        };

        $scope.firstLoad();
}]);